<script>
    import Organization from './Organization.svelte';

    import { Routes, pushRoute } from '../router.js';
    import { page } from '../stores.js';

    export let loggedIn = false;

    function onToIndex() {
        pushRoute(Routes.INDEX);
    }

    function onToSettings() {
        pushRoute(Routes.SETTINGS);
    }
</script>

<div class="header">
    <img src="logo.svg" alt="Campuspano Logo" on:click={onToIndex} >
    {#if loggedIn}
        <Organization />
    {/if}
</div>

<style>
    .header {
        background-color: var(--white);
        color: var(--off-black);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        box-shadow: var(--box-shadow);
    }

    img {
        width: 300px;
    }

    img:hover {
        cursor: pointer;
    }
</style>
